// eslint-disable-next-line import/prefer-default-export
export const centsToDollars = (amount: number) => {
  const cents = amount / 100
  return cents.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}
